import { Component, OnInit } from '@angular/core';
import * as RecordRTC from 'recordrtc';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';
declare var $:any;
interface RecordedVideoOutput {
  blob: Blob;
  url: string;
  title: string;
}
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit {
  filespath:any;
  private stream: any;
  private recorder: any;
  private interval: any;
  invokeSaveAsDialog: any;
  private startTime: any;
  private _stream = new Subject<MediaStream>();
  private _recorded = new Subject<RecordedVideoOutput>();
  private _recordedUrl = new Subject<string>();
  private _recordingTime = new Subject<string>();
  private _recordingFailed = new Subject<string>();
  getRecordedUrl(): Observable<string> {
    return this._recordedUrl.asObservable();
  }

  getRecordedBlob(): Observable<RecordedVideoOutput> {
    return this._recorded.asObservable();
  }

  getBlob(): Observable<RecordedVideoOutput> {
    return this._recorded.asObservable();
  }

  getRecordedTime(): Observable<string> {
    return this._recordingTime.asObservable();
  }

  recordingFailed(): Observable<string> {
    return this._recordingFailed.asObservable();
  }

  getStream(): Observable<MediaStream> {
    return this._stream.asObservable();
  }

  startRecording() {
    var browser = <any>navigator;
    if (this.recorder) {
      // It means recording is already started or it is already recording something
      return;
    }

    this._recordingTime.next('00:00');

    return new Promise((resolve, reject) => {
      browser.mediaDevices
        .getDisplayMedia({
          video: {
            displaySurface: 'browser', // monitor, window, application, browser
            logicalSurface: true,
            cursor: 'always', // never, always, motion
          },
        })
        .then((screenStream: any) => {
          navigator.mediaDevices.getUserMedia({ audio: true }).then((mic) => {
            screenStream.addTrack(mic.getTracks()[0]);
            this.stream = screenStream;
            this.record();
            resolve(this.stream);
          });
        })
        .catch((error: any) => {
          this._recordingFailed.next();
          reject;
        });
    });
  }

  abortRecording() {
    this.stopMedia();
  }

  public record() {
    this.recorder = new RecordRTC(this.stream, {
      type: 'video',
      mimeType: 'video/webm',
      bitsPerSecond: 44000,
    });
    this.recorder.startRecording();
    this.startTime = moment();
    this.interval = setInterval(() => {
      const currentTime = moment();
      const diffTime = moment.duration(currentTime.diff(this.startTime));
      const time =
        this.toString(diffTime.minutes()) +
        ':' +
        this.toString(diffTime.seconds());
      this._recordingTime.next(time);
      this._stream.next(this.stream);
    }, 500);
  }

  private toString(value: any) {
    let val = value;
    if (!value) {
      val = '00';
    }
    if (value < 10) {
      val = '0' + value;
    }
    return val;
  }

  stopRecording() {
    if (this.recorder) {
      this.recorder.stopRecording(this.processVideo.bind(this));
      this.processVideo.bind(this.recorder);
      this.processVideo(this.recorder);
      this.stopMedia();
      
    }
    
  }

  private processVideo(audioVideoWebMURL: any) {
    console.log(audioVideoWebMURL);
    $("#video").attr("src", audioVideoWebMURL)​
    // var file = new File([audioVideoWebMURL],'test');
    // const recordedName = encodeURIComponent(
    //   'video_' + new Date().getTime() + '.webm'
    // );
    // var file = this.blobToFile(audioVideoWebMURL,recordedName);
    // console.log(file);

    // this.filespath = file;
    
    var mimeType = 'video/webm';
    var fileExtension = 'webm';
    var fileName = this.getFileName(fileExtension);
    
    // var blob = this.recorder instanceof Blob ? this.recorder : this.recorder.getBlob();
    var file = new File([this.recorder.getBlob()], fileName, {
      type: mimeType
    });

    this.filespath = file;
    console.log(file);



    // const recordedBlob = this.recorder.getBlob();
    // var blob = this.recorder.getBlob();
    // console.log(recordedBlob);
    // this.recorder.getDataURL(function (dataURL: any) {});
    // const recordedName = encodeURIComponent(
    //   'video_' + new Date().getTime() + '.webm'
    // );
    // var test =this._recorded.next({
    //   blob: recordedBlob,
    //   url: audioVideoWebMURL, 
    //   title: recordedName,
    // });
    console.log('video processing');
    // console.log(test);
    console.log(this._recorded.next());
    let recordurlvalue = this.getRecordedUrl();
    console.log(recordurlvalue);
    this.stopMedia();

    
    // this.recorder.save(recordedName);
  }
  private stopMedia() {
    if (this.recorder) {
      this.recorder = null;
      clearInterval(this.interval);
      this.startTime = null;
      if (this.stream) {
        this.stream.getAudioTracks().forEach((track: any) => track.stop());
        this.stream.getVideoTracks().forEach((track: any) => track.stop());
        this.stream.stop();
        this.stream = null;
      }
    }
  }
  constructor() { }

  ngOnInit(): void {

  }


  public blobToFile = (theBlob: Blob, fileName:string): File => {       
    return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: 'video/webm' })
}

updatedthePath(){

  let access_token: any=localStorage.getItem('access_token');
  let user_id: any =  localStorage.getItem('userId'); 
  let admin_ids: any =  localStorage.getItem('admin_id'); 
  let ref_ids: any = '1';
  let api_req:any = new Object();
  let agent_req:any = new Object();
 let files = this.filespath;
  var formData = new FormData();

  // var file_testing = new File([$("#video").attr("src")],'test');
  // console.log(file_testing);

  formData.append('operation', 'screen_recording_upload');
  formData.append('moduleType', 'call');
  formData.append('api_type', 'web');
  formData.append('access_token', access_token);
  formData.append('admin_id', admin_ids);
  formData.append('ref_id', ref_ids);
  // formData.append('attachment',$("#video").attr("src"));
  formData.append('attachment', files);
  formData.append('action', 'screen_recording_upload');


  $.ajax({    
    url:"https://updates.mconnectapps.com/Thilak12042022B/api/v1.0/index_new.php",  
    type : 'POST',
    data : formData,
    processData: false,  // tell jQuery not to process the data
    contentType: false, 
    success:function(data){ 
      // Swal.close();
 
 
    }  
});  
}



 getFileName(fileExtension) {
  var d = new Date();
  var year = d.getUTCFullYear();
  var month = d.getUTCMonth();
  var date = d.getUTCDate();
  return 'RecordRTC-' + year + month + date + '-' +'.' + fileExtension;
}




}
